import locale from './menuLanguage';
export default {
    // menu: [{
    //     'mainTitle': locale.logisticsMenu.logisCurrentPosition,
    //     'link': '/admin.html#/',
    //     'type': 'Group', // 没有子菜单
    //     'alias': 'adminService',
    //     'id': 11
    // }],
    adminService: [{
        'mainTitle': locale.logisticsMenu.logisCurrentPosition, // 当前位置
        'link': '/admin.html#/',
        'type': 'Group', // 没有子菜单
        'alias': 'logisManagement',
        'id': 1
        },
        {
            'mainTitle': locale.logisticsMenu.logisManagement, // 基础信息管理
            'type': 'Group-base',
            'icon': 'icon-shenhe',
            'id': 11,
            'pid': 1
        },
        {
            'mainTitle': locale.logisticsMenu.dataReview,// 资料审核管理
            'id': 101,
            'pid': 11,
            'link': '/admin.html#/dataReview',
            'menuKey': 'dataReview'
        },
        {
            'mainTitle': locale.logisticsMenu.carrierAccount,// 物流账号管理
            'id': 102,
            'pid': 11,
            'link': '/admin.html#/carrierAccount',
            'menuKey': 'carrierAccount'
        },
        {
              'mainTitle': locale.logisticsMenu.carrierParam,// 物流信息管理
              'id': 103,
              'pid': 11,
              'link': '/admin.html#/carrierInfoAdmin',
              'menuKey': 'carrierInfoAdmin'
        },
        {
            'mainTitle': locale.logisticsMenu.FreightForwarding,// 货代
            'secondMenu': 'second-menu',
            'id': 104,
            'pid': 11
        },
        {
            'mainTitle': locale.logisticsMenu.channelManagement,// 渠道管理
            'id': 111,
            'pid': 104,
            'icon': '',
            'link': '/admin.html#/logisManagement',
            'menuKey': 'logisManagement'
        },
        {
            'mainTitle': locale.logisticsMenu.OverseasWarehouse,// 海外仓
            'secondMenu': 'second-menu',
            'id': 105,
            'pid': 11
        },
        {
            'mainTitle': locale.logisticsMenu.warehouseManagement,//仓库管理
            'id': 112,
            'pid': 105,
            'icon': '',
            'link': '/admin.html#/warehosue',
            'menuKey': 'warehosue'
        },
        {
            'mainTitle': locale.logisticsMenu.channelManagement,//渠道管理
            'id': 113,
            'pid': 105,
            'icon': '',
            'link': '/admin.html#/owchannelManagement',
            'menuKey': 'owchannelManagement'
        },
        {
            'mainTitle': locale.logisticsMenu.logisBizManagement, // 业务信息管理
            'type': 'Group-biz',
            'icon': 'icon-shenhe',
            'id': 12,
            'pid': 1
        },
        {
            'mainTitle': locale.logisticsMenu.logManagement,// 日志管理
            'id': 106,
            'pid': 12,
            'link': '/admin.html#/logManagement',
            'menuKey': 'logManagement'
        },
        {
            'mainTitle': locale.logisticsMenu.packageInfo,// 被动对接包裹信息
            'id': 107,
            'pid': 12,
            'link': '/admin.html#/packageInfo',
            'menuKey': 'packageInfo'
        },
        {
            'mainTitle': locale.logisticsMenu.statisticsPackageInfo,// 包裹统计
            'id': 108,
            'pid': 12,
            'link': '/admin.html#/statisticsPackageInfo',
            'menuKey': 'statisticsPackageInfo'
        },
        {
            'mainTitle': locale.logisticsMenu.logisAccessManagement, // 访问管理
            'type': 'Group-access',// Group-title
            'icon': 'icon-shenhe',
            'id': 13,
            'pid': 1
        },
        {
            'mainTitle': locale.logisticsMenu.accessStatistics_admin,// 访问频率管理
            'id': 109,
            'pid': 13,
            'link': '/admin.html#/accessStatistics',
            'menuKey': 'accessStatistics'
        }
    ]
};


// WEBPACK FOOTER //
// ./src/api/menuAdmin.js